module.exports = __webpack_public_path__ + "static/media/micro_services_image.06b1acbd.jpg";